import {
  Alert,
  AlertTitle,
  Collapse,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import { Controller, UseFormReturn } from 'react-hook-form';
import { AssessmentCard } from '../../shared';
import { rules } from '../../demographics/rules';
import { MedicationPharmacyFormValues } from '.';

type PropTypes = {
  form: UseFormReturn<MedicationPharmacyFormValues>;
  onOptionChange: (option: string) => void;
};

const PharmacyQuestion = ({ form, onOptionChange }: PropTypes) => {
  const radioOptions = ['Yes', 'No'];
  const { control, watch } = form;
  const doesNotHavePharmacy = watch('hasPharmacy') === 'No';

  return (
    <AssessmentCard>
      <Typography component="h3" variant="h5" sx={{ mb: 1 }}>
        Do you have a pharmacy you like to use?
      </Typography>
      <Controller
        name="hasPharmacy"
        control={control}
        rules={rules.requiredCheckboxOrRadio as any}
        render={({ field, fieldState }) => (
          <FormControl error={!!fieldState.error}>
            <RadioGroup {...field}>
              {radioOptions.map((option, index) => (
                <FormControlLabel
                  control={<Radio />}
                  key={`assessment-radio-key${index}`}
                  label={option}
                  value={option}
                  onChange={() => onOptionChange(option)}
                />
              ))}
            </RadioGroup>
          </FormControl>
        )}
      />
      <Collapse in={doesNotHavePharmacy} unmountOnExit>
        <Alert severity="warning" sx={{ mt: 2 }}>
          <AlertTitle>Medication and prescriptions</AlertTitle>
          In case medication is a part of your treatment plan, we need a
          pharmacy on file so we’ll know where to send it.
        </Alert>
      </Collapse>
    </AssessmentCard>
  );
};

export default PharmacyQuestion;
